import React, { useState, useEffect } from "react";
import HeaderMiniso from "../Home/HeaderMiniso/HeaderMiniso";
import MyFooter from "../Home/MyFooter/MyFooter";
import { pinguinoAzulRegistro } from "../../assets/ImgLinks";
import useUser from "../../hooks/useUser";
import { newUserByFormAptosVetex } from "../../api/apiNewUser";
import WelcomeMinisoLover from "../Home/WelcomeMinisoLover";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { getVariableByShortName } from "../../api/apiVariable";

const RetryRegisterExpress = () => {
  const [
    dataUser,
    setDataUser,
    dataAdmin,
    setDataAdmin,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage,
  ] = useUser();
  const [showWelcome, setShowWelcome] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showError, setShowError] = useState(true);
  const [isTrying, setIsTrying] = useState(true);
  const [isCancel, setIsCancel] = useState(false);
  const [dataTemp, setDataTemp] = useState({});
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isExpress, setIsExpress] = useState(false);
  const [isActiveExpress, setIsActiveExpress] = useState(true);


  useEffect(() => {
    const getExpressStatus = async () => {
      const response = await getVariableByShortName("express");
      console.log('response statusExpress: ',response);
      if (response?.data?.status) {
        if(String(response.data.status).toUpperCase()==="ON"){
          setIsActiveExpress(true);
        }else{
          setIsActiveExpress(false);
        }
        
      }
    };
    getExpressStatus();
  }, []);

  //pruebaExpress250823001@test.com
  useEffect(() => {
    console.log("dataLocalStorage", dataLocalStorage);
    if(dataLocalStorage.email!==false){
        setDataTemp({...dataLocalStorage})
    }
    if (
      (dataLocalStorage.email =
        "" ||
        dataLocalStorage.email === undefined ||
        dataLocalStorage.email === null ||
        dataLocalStorage.email === "default"
        
        )
    ) {
      
        navigate("/registro_express");
      
        
    }
  }, [dataLocalStorage]);

  useEffect(() => {
    console.log("searchParams", searchParams);
    if (searchParams.get("express") === "true") {
      console.log("es express");
      setIsExpress(true);
    }
  }, [searchParams]);
  const handleRetry = async () => {
    console.log("reintentar registro", dataTemp);
    if(dataTemp?.email===false||dataTemp?.email===undefined||dataTemp?.email===null||dataTemp?.email==='default'){
        console.log('no hay datos para reintentar registro');
        return
    }
    //setShowSpinner(true);
    try {
      setShowSpinner(true);
      const response = await newUserByFormAptosVetex(dataTemp);
      console.log('response Backend(retry):',response);
      const { idAptos, idCL, idMF } = response?.data;
      if (idAptos && idCL && idMF) {
        console.log("registro exitoso");
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          dataID: {
            idAptos,
            idCL,
            idMF,
          },
        });
        setShowWelcome(true);
        setDataLocalStorage({});
        setIsTrying(false);
        
        setShowError(false);
      }
      if(response){
        setShowSpinner(false);
      }

      
      
    } catch (error) {
      console.log('Error al intentar Registrar(retry):..',error);
      setInterval(() => {
        setShowSpinner(false);  
      }, 3000);
      
    }
  };
  const handleCancel = () => {
    console.log("cancelar registro");
    setIsCancel(true);
    setDataLocalStorage({});
    setDataUser({
      ...dataUser,
      
      cancelRetraying: true,
    });

    setIsTrying(false);
    //window.location.reload();
    setTimeout(() => {
      navigate("/registro_express");
    }, 3000);
  };

  return (
    <>
    {isActiveExpress===false? (
      <>
      <HeaderMiniso />
      <div className="alert alert-danger my-5 p-5">
        <h3 className="text-center fs-3">El registro express se encuentra deshabilitado</h3>
        <p className="text-muted text-center">sentimos los incovenientes</p>
      </div>
      <MyFooter />
      </>
    ):(
<div>
      <HeaderMiniso />
      <div className="p-3">
        <div className="d-flex align-items-center justify-content-center">
          <img
            style={{ width: "20vw" }}
            className="rounded"
            src={pinguinoAzulRegistro}
            alt="pinguinoAzulRegistro"
          />
          <h3 style={{ color: "#3ABDBC" }} className="fs-1 ms-3">
            REGISTRO
          </h3>
        </div>
      </div>
      
      {isTrying && (
        <div className="d-flex justify-content-center aligng-align-items-center gap-3 my-3">
          <button className="btn btn-primary" onClick={handleRetry}>
            Reintentar Registro
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            Cancelar Registro
          </button>
        </div>
      )}
      {isCancel && (
        <h3 className="text-center text-muted my-3 fs-3">
          Tu registro ha sido cancelado gracias.
        </h3>
      )}
      {showSpinner && <span className="d-flex justify-content-center"><Spinner /></span>}
      {showError&& <h3 className="text-danger fs-6 text-center my-2">Al parecer existe un problema con el acceso a Internet</h3>}
      {showWelcome && <WelcomeMinisoLover />}

      <MyFooter />
    </div>
    )}
    
    </>
  );
};

export default RetryRegisterExpress;
